throw new Error(`No exports are available from the top-level "@clerk/elements" package.
Use specific subpath imports instead, e.g. "@clerk/elements/sign-in".

Find all available exports in the documentation:
https://clerk.com/docs/elements/overview`);
